module.exports = __webpack_public_path__ + "static/media/footerAyasa.a07d0064.png";